import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OpportunityScheduleEdService from '../../../Services/opportunityScheduleEdService';
import OpportunityScheduleEdLinkItem from '../../../Domain/OpportunityScheduleEdLinkItem';

// Send Schedule D/E Link (CD-5433): one field, so the wizard renders it as the compact centred modal - same
// shape as ImportContractUploadWindowDescription. Opened from the Opportunity row's actions menu; there is no
// Schedule D/E tab, since sending is a one-off action rather than a view. Eligibility is enforced by the
// microservice and reflected in the menu item's disabled state, so it is not restated here.
export default class SendScheduleEdLinkWindowDescription {
  static titleForCreate = 'Send Schedule D/E Link';
  static titleForEdit = 'Send Schedule D/E Link';
  static itemType = OpportunityScheduleEdLinkItem;
  static finishButtonLabel = 'Send link';
  static messageOnSuccess = 'The Schedule D/E link has been sent to the selected contact.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'Contact',
      fields: [
        {
          fieldName: 'ContactId',
          label: 'Client Contact',
          className: 'col-12',
          // Active contacts of this client, labelled with the address the link will go to. idFilter names the
          // edited-item field to scope by.
          type: InputTypesEnum.ActiveContactSelectWithEmail,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  // A resend invalidates the still-usable link the contact may already be holding, so it is confirmed first.
  static shouldConfirmResend = (edited) => !!edited.ScheduleEDLinkSent;

  static resendWarning =
    'A Schedule D/E link has already been sent for this Opportunity. Sending a new one will immediately ' +
    'invalidate the previous link, even if the contact has not used it yet. Do you want to proceed?';

  static serviceFunction = (edited) => OpportunityScheduleEdService.SendLink(edited.OpportunityId, edited.ContactId);
}
